import { Dayjs } from "dayjs";

export enum EnumBloqueioTipo
{
    Manual = 1,
    Inadimplencia  = 2
}

export default interface BloqueioTipo
{
    codigo : number;
    nome : string;
    ativo : boolean;
    codOperador : number;
    dataCriacao : Date | Dayjs;
}